module.exports = __webpack_public_path__ + "static/media/logo-text-only.c2c0d423.png";